import { gql } from "@apollo/client";

export const MUTATION_CREATE_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $amount: Int
    $applyReserveHoldback: Boolean
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $loadId: String
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringAmount: Int
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
    $nonFactored: Boolean
    $nonFactoredType: String
    $additionalDiscountRate: Decimal
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        applyReserveHoldback: $applyReserveHoldback
        amount: $amount
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        loadId: $loadId
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringAmount: $factoringAmount
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
        nonFactored: $nonFactored
        nonFactoredType: $nonFactoredType
        additionalDiscountRate: $additionalDiscountRate
      }
    ) {
      fundingRequest {
        id
        contractType
        warnings
        # the following fields are only used by Cypress:
        amount
        billToCompanyEmail
        loadTrailerType
        invoiceNumber
        paymentMethod
        paymentProfilePaymentMethod
        carrierPaymentStatus
        applyReserveHoldback
      }
    }
  }
`;

export const MUTATION_CREATE_DIRECT_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $amount: Int
    $applyReserveHoldback: Boolean
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringAmount: Int
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
    $originLocations: [LoadLocationInputType]
    $destinationLocations: [LoadLocationInputType]
    $loadWeight: Int
    $trailerType: String
    $timeStart: DateTime
    $timeEnd: DateTime
    $timeDelivery: DateTime
    $noLoad: Boolean
    $nonFactored: Boolean
    $nonFactoredType: String
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        amount: $amount
        applyReserveHoldback: $applyReserveHoldback
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringAmount: $factoringAmount
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
        originLocations: $originLocations
        destinationLocations: $destinationLocations
        loadWeight: $loadWeight
        trailerType: $trailerType
        timeStart: $timeStart
        timeEnd: $timeEnd
        timeDelivery: $timeDelivery
        noLoad: $noLoad
        nonFactored: $nonFactored
        nonFactoredType: $nonFactoredType
      }
    ) {
      fundingRequest {
        id
        contractType
        warnings
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $id: String
    $amount: Int
    $debtor: String
    $paymentProfileAmount: Int
    $userLoadNumber: String
    $loadLength: Int
    $paymentProfilePaymentMethod: String
    $paymentProfileId: String
    $factoringAmount: Int
    $factoringFeeSplitRate: Int
    $payoutDays: String
    $lineItems: [LineItemInput]
    $contractType: String
    $carrierProNumber: String
    $purchaseOrderNumber: String
  ) {
    createOrUpdateBrokerFundingRequest(
      input: {
        id: $id
        amount: $amount
        debtor: $debtor
        paymentProfileAmount: $paymentProfileAmount
        userLoadNumber: $userLoadNumber
        loadLength: $loadLength
        paymentProfilePaymentMethod: $paymentProfilePaymentMethod
        paymentProfileId: $paymentProfileId
        factoringAmount: $factoringAmount
        factoringFeeSplitRate: $factoringFeeSplitRate
        payoutDays: $payoutDays
        lineItems: $lineItems
        contractType: $contractType
        carrierProNumber: $carrierProNumber
        purchaseOrderNumber: $purchaseOrderNumber
      }
    ) {
      fundingRequest {
        id
        warnings
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST_TYPE = gql`
  mutation CreateOrUpdateBrokerFundingRequest(
    $id: String
    $contractType: String
    $selfFinanceRequested: Boolean
  ) {
    createOrUpdateBrokerFundingRequest(
      input: { id: $id, contractType: $contractType, selfFinanceRequested: $selfFinanceRequested }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_BROKER_FUNDING_REQUEST_STATUS = gql`
  mutation CreateOrUpdateBrokerFundingRequest($id: String, $status: String) {
    createOrUpdateBrokerFundingRequest(input: { id: $id, status: $status }) {
      fundingRequest {
        id
      }
    }
  }
`;

export const QUERY_AUTO_GENERATED_LOAD_NUMBER = gql`
  query AutogeneratedLoadNumber {
    autogeneratedLoadNumber
  }
`;
